import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';

@Injectable({
  providedIn: 'root'
})
export class ConstantQueryService {
  InvestmentManagerQuery: string;
  AssetSummaryQuery: string;
  IconSetQuery: string;
  loginLandingPage: DocumentNode;
  landingPageByIDQuery: string;
  headerQuery: string;
  sessionTimeOutQuery: string;
  pageNotFoundQuery: DocumentNode;
  financialValues: string[];

  constructor() {
    this.InvestmentManagerQuery = `query investmentManagerCollectionQuery($masterId: Int!, $previewFlag: Boolean!) {
      investmentManagerCollection(preview: $previewFlag, where: { masterId: $masterId }, limit: 1) {
        items {
          masterId
          name
          logo {
            url
          }
        }
      }
    }`;

    this.AssetSummaryQuery = `query assetDetailsCollectionQuery($masterId: Int!, $previewFlag: Boolean!){
      assetDetailsCollection(preview: $previewFlag, where: { masterId: $masterId }, limit: 1) {
        items {
          masterId
          name
          assetUrl
          logo {
            url
          }
          summary {
            json
          }
          photosCollection {
            items {
              url
            }
          }
          map {
            lat
            lon
          }
        }
      }
    }`

    this.IconSetQuery = `query iconCollectionQuery($previewFlag: Boolean!) {
      iconCollection(preview: $previewFlag) {
        items {
          key
          iconImage {
            url
          }
        }
      }
    }`;

    this.loginLandingPage = gql` query landingPageEntryQuery($previewFlag:Boolean!) {
      landingPage(id: "21IXOLC0LZfm9Hr1vfZTyS", preview: $previewFlag) {
        sys {
          id
        }
        internalName
        backgroundImage {
          url
        }
        clientScopeLogo {
          url
        }
        gcmLogo {
          url
        }
        gcmGrosvenorWebPortalUserAgreement {
          url
        }
        sectionsCollection {
          items {
            ...resourceSetFields
            ...brandingFields
            ... on RichTextContents {
              contents {
                json
              }
            }
          }
        }
      }
    }
    fragment resourceSetFields on ResourceSet {
      name
      resourcesCollection {
        items {
          ... on Resource {
            key
            value
          }
        }
      }
    }
    fragment brandingFields on Branding {
      internalName
      heading
      copyright
      logo {
        url
      }
      content
      {
        json
      }
    }`;

    this.landingPageByIDQuery = `query landingPageEntryQuery($id: String!, $previewFlag: Boolean!) {
      landingPage(id: $id, preview: $previewFlag) {
        internalName
        backgroundImage {
          url
        }
        sectionsCollection {
          items {
            ... on ResourceSet {
              name
              resourcesCollection {
                items {
                  ... on Resource {
                    internalName
                    key
                    value
                  }
                }
              }
            }
          }
        }
      }
    }`;

    this.headerQuery = `query headerEntryQuery($previewFlag: Boolean!) {
      header(id: "24vTFpdgVim1axOOtPA9Oa", preview: $previewFlag) {
        sys {
          id
        }
        name
        logo {
          url
        }
        iconsCollection {
          items {
            iconImage {
              fileName
              url
            }
          }
        }
        labelsCollection {
          items {
            __typename
            ...resourceSetFields
          }
        }
        clientScopeLogo {
          url
        }
      }
    }
    fragment resourceSetFields on ResourceSet {
      resourcesCollection {
        items {
          ... on Resource {
            key
            value
          }
        }
      }
    }`;

    this.sessionTimeOutQuery = `query sessionTimeoutSectionEntryQuery($previewFlag: Boolean!) {
      sessionTimeoutSection(id: "61SpRO5La0RV4nZu1ebP15", preview: $previewFlag) {
        sys {
          id
        }
        image {
          url
        }
        headingText1
        headingText2
        description {
          json
        }
        logOutButtonText
        continueButtonText
      }
    }`;

    this.pageNotFoundQuery = gql`query page404ErrorEntryQuery($previewFlag: Boolean!) {
      page404Error(id: "5aDBDp77JCl95zLo0qwLLW", preview: $previewFlag) {
        sys {
          id
        }
        name
        gcmLogo {
          url
        }
        errorImage {
          url
        }
        emailAddressText
        mailToEmailAddress
        pageText
        pageTitle
        goToDashboardButtonText
      }
    }`;

    this.financialValues = [
      "value",
      "revenue",
      "ebitda",
      "netDebt",
      "netLeverage",
      "riskProfile",
      "marketCap",
      "acquisitionPrice",
      "entryLoanToValue",
      "underwrittenDispositionPrice",
      "underwrittenHoldTermValue"
    ]
  }
}
